import { Component } from '@angular/core';
import { environment } from '@env//environment.local';
import { CalculateDiroOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/calculate-diro/calculate-diro-wrapper.component';

@Component({
  selector: 'app-calculate-diro',
  templateUrl: './calculate-diro.component.html',
  styleUrls: ['./calculate-diro.component.scss'],
})
export class CalculateDiroComponent extends CalculateDiroOpenQuoteWrapper {
  constructor() {
    super();
  }
}
